import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import GalleryImg from "../Assets/24.jpeg"
import Footer from "../components/Footer";
import ImageGallery from "../components/ImageGallery";
import FloatingButton from "../components/FloatingButton";
import GalleryText from "../components/GalleryText";
function Gallery(){
    return (
        <>
             <Navbar/>
       <Hero
   cName="hero-mid"
   heroImg={GalleryImg}
   title="Life at Jupiter"
   btnClass="hide"
   />
   <GalleryText/>
   <ImageGallery/>
   <FloatingButton/>
   <Footer/>
        </>
    )
    }
    
    export default Gallery;